export default "__VITE_ASSET__DimG2eQD__"